var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"serviceinfo"}},[_c('h2',{directives:[{name:"focus",rawName:"v-focus"}],staticClass:"sr-only",attrs:{"tabindex":"0"}},[_vm._v("服務紀錄")]),_c('serviceinfo-record',{attrs:{"user_id":_vm.user.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }